const messages: Record<string, string> = {
	'vehicleRegistrationDocument.title': 'Prometna dozvola vozila',
	'vehicleRegistrationDocument.description':
		'Prenesite jasne fotografije traženih strana prometne dozvole.',
	'vehicleRegistrationDocument.RegistrationDocument.title': 'Prednja strana prometne dozvole',
	'vehicleRegistrationDocument.RegistrationDocument.description':
		'Snimite jasnu fotografiju prednje strane prometne dozvole.',
	'vehicleRegistrationDocument.RegistrationDocument.headline': 'Prednja strana prometne dozvole',
	'vehicleRegistrationDocument.RegistrationDocument.exampleModalTitle':
		'Prednja strana prometne dozvole - primjer',
	'vehicleRegistrationDocument.RegistrationDocument.validationRequired':
		'Prednja strana prometne dozvole',
	'vehicleRegistrationDocument.RegistrationDocumentInside.title':
		'Stražnja strana prometne dozvole',
	'vehicleRegistrationDocument.RegistrationDocumentInside.description':
		'Snimite jasnu fotografiju stražnje strane prometne dozvole.',
	'vehicleRegistrationDocument.RegistrationDocumentInside.headline':
		'Stražnja strana prometne dozvole',
	'vehicleRegistrationDocument.RegistrationDocumentInside.exampleModalTitle':
		'Stražnja strana prometne dozvole - primjer',
	'vehicleRegistrationDocument.RegistrationDocumentInside.validationRequired':
		'Stražnja strana prometne dozvole',
	'vehicleRegistrationDocument.validationHeadline': 'Nedostaju fotografije',
	'vehicleRegistrationDocument.validationDescription': 'Dodajte sljedeće fotografije:',
	'landing.stepDescription.vehicleRegistrationDocument': 'Fotografirajte prometnu dozvolu',
	'review.stepDescription.vehicleRegistrationDocument': 'Prometna dozvola vozila',
	'loader.loading': 'Učitavanje…',
	'loader.error': 'Učitavanje neuspješno. Molimo pokušajte kasnije…',
	'connectionError.title': 'Greška prilikom spajanja',
	'connectionError.description':
		'Greška prilikom spajanja. Molimo učitajte fotografije još jednom.',
	'mainError.tryAgain': 'Pošušajte ponovno',
	'landing.headline.policyCheck': 'Pozdrav',
	'landing.termsAndConditionsLinkDescription':
		'Pritiskom na "Kreni" prihvaćaš naše <tclink>uvjete</tclink>',
	'landing.paragraph': 'Još samo dva koraka do završetka digitalnog pregleda vozila',
	'landing.stepDescription.fourDiagonalPerspectives': 'Fotografiraj prema uputama',
	'landing.stepDescription.feedback': 'Javi nam povratnu informaciju',
	'landing.termsAndConditionsLink': 'Pritiskom na "Kreni" prihvaćaš naše uvjete',
	'button.start': 'KRENI',
	'button.close': 'OK',
	'landing.aboutPolicyCheck': 'Natrag',
	'tutorialModal.headline.first.policyCheck':
		'Što se podrazumijeva pod digitalnim pregledom vozila?',
	'tutorialModal.paragraph.first.policyCheck':
		'Digitalni pregled vozila je brza provjera stanja vozila na temelju dostavljenih fotografija. Proces se sastoji od 8 jednostavnih koraka.',
	'chooseLang.headline': 'Odaberite željeni jezik',
	'blockedByDevice.headline': 'Digitalni pregled vozila nije podržan na računalnim preglednicima ',
	'blockedByDevice.description':
		'Aplikaciji za digitalni pregled vozila je moguće pristupiti preko mobilnih uređaja. Kako biste nastavili, molimo pokrenite aplikaciju preko mobilnog uređaja.',

	'vehicleImages.overviewPhotos': 'Pregled vozila',
	'vehicleImages.description':
		'Fotografiraj vozilo sa svih strana. Registarska oznaka mora se jasno vidjeti na svim fotografijama.',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': 'Prednja lijeva dijagonala',
	'fourDiagonalPerspectives.vehicleRearLeft.title': 'Stražnja lijeva dijagonala',
	'fourDiagonalPerspectives.vehicleRearRight.title': 'Stražnja desna dijagonala',
	'fourDiagonalPerspectives.vehicleFrontRight.title': 'Prednja desna dijagonala',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Primjer',
	'button.next': 'Dalje',

	'imageRecognitionMismatchModal.headline': 'Provjerimo jesu li fotografije ispravno učitane.',
	'button.continue': 'Nastavi',
	'button.backchangeImage': 'FOTOGRAFIRAJ PONOVO',

	'vehicleImages.leftFrontOverview': 'Prednja lijeva dijagonala',
	'vehicleImages.leftRearOverview': 'Stražnja lijeva dijagonala',
	'vehicleImages.rightRearOverview': 'Stražnja desna dijagonala',
	'vehicleImages.rightFrontOverview': 'Prednja desna dijagonala',
	'button.changeImage': 'FOTOGRAFIRAJ PONOVO',

	'completeVehicleImagesModal.headline': 'Nešto nedostaje',
	'completeVehicleImagesModal.description': 'Molimo dodaj sljedeće fotografije:',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'Prednja lijeva dijagonala',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'Stražnja lijeva dijagonala',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Stražnja desna dijagonala',
	'completeVehicleImagesModal.hasVehicleImageFrontRight': 'Prednja desna dijagonala',
	'button.ok': 'OK',

	'fourPerspectivesExampleModal.headline.first': 'Primjer fotografije prednje lijeve dijagonale',
	'fourPerspectivesExampleModal.headline.second': 'Primjer fotografije stražnje lijeve dijagonale',
	'fourPerspectivesExampleModal.headline.third': 'Primjer fotografije stražnje desne dijagonale',
	'fourPerspectivesExampleModal.headline.fourth': 'Primjer fotografije prednje desne dijagonale',
	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle':
		'Primjer fotografije prednje lijeve dijagonale',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle':
		'Primjer fotografije stražnje lijeve dijagonale',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle':
		'Primjer fotografije stražnje desne dijagonale',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle':
		'Primjer fotografije prednje desne dijagonale',
	'fourPerspectivesExampleModal.button.close': 'OK',

	'button.prev': 'Natrag',
	'fourAdditionalPictures.title': 'Dodatne informacije',
	'fourAdditionalPictures.overallDashboard.title': 'Upravljačka ploča',
	'fourAdditionalPictures.overallDashboard.description':
		'Fotografiraj tako da se vidi cijela upravljačka ploča vozila.',
	'fourAdditionalPictures.mileage.title': 'Broj prijeđenih kilometara',
	'dashboardMileage.dashboard.paragraph':
		'Fotografiraj prijeđene kilometre. Ako vozilo ima digitalni zaslon, upali ga prije fotografiranja.',
	'dashboardMileage.paragraph.first': 'Upiši ukupno prijeđene kilometre.',
	'dashboardMileage.input.error': 'Molimo unesite trenutni broj prijeđenih kilometara vozila.',
	'dashboardMileage.placeholder': 'Trenutni broj prijeđenih kilometara.',
	'fourAdditionalPictures.windshield.title': 'Vjetrobransko staklo',
	'fourAdditionalPictures.windshield.description':
		'Fotografiraj prednje vjetrobransko staklo izbliza.',
	'fourAdditionalPictures.vin.title': 'Broj šasije',
	'fourAdditionalPictures.vin.description':
		'Fotografiraj broj šasije vozila. Nalazi se na brtvi vozačevih vrata ili u donjem lijevom kutu vjetrobranskog stakla.',

	'imageRecognitionMistmatchModal.headline': 'Provjerimo jesu li fotografije ispravno učitane.',
	'completeFourAdditionalPicturesModal.headline': 'Nešto nedostaje',
	'completeFourAdditionalPicturesModal.description': 'Molimo dodaj sljedeće fotografije:',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage': 'Upravljačka ploča',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Broj prijeđenih kilometara',
	'completeFourAdditionalPicturesModal.hasWindshieldImage': 'Vjetrobransko staklo',
	'completeFourAdditionalPicturesModal.hasVINImage': 'Broj šasije',
	'completeDashboardMileageModal.hasValidMileage':
		'Molimo unesite trenutni broj prijeđenih kilometara vozila.',

	'mismatchModal.enteredMileage': 'Upisani prijeđeni kilometri',

	'overallDashboardImage.headline': 'Upravljačka ploča',
	'dashboardMileage.dashboard.title': 'Broj prijeđenih kilometara',
	'windshieldImage.headline': 'Vjetrobransko staklo',
	'vinPicture.headline': 'Broj šasije',

	'fourAdditionalPictures.overallDashboard.exampleModalTitle':
		'Primjer fotografije upravljačke ploče',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Primjer fotografije prijeđenih kilometara',
	'fourAdditionalPictures.windshield.exampleModalTitle':
		'Primjer fotografije vjetrobranskog stakla',
	'fourAdditionalPictures.vin.exampleModalTitle': 'Primjer fotografije šasije',
	'fourAdditionalPicturesExampleModal.button.close': 'OK',

	'upload.message': 'Tvoji podaci se učitavaju. Ovaj proces može trajati i nekoliko minuta.',

	'review.button.next': 'Dalje',

	'feedback.headline.policyCheck': 'Sve fotografije uspješno su učitane!',
	'feedback.rating.policyCheck': 'Ocijeni aplikaciju!',
	'feedback.yourOpinion': 'Imaš komentar? Napiši nam!',

	'feedback.comment.placeholder': 'Dodaj komentar',
	'feedback.button.send': 'Pošalji',

	'thanks.headline.first': 'Hvala na povratnoj informaciji!',
	'waitForAudit.thankYou': 'Digitalni pregled vozila je već završen. Hvala!',

	'thanks.paragraph.first': ' ',
	'waitForAudit.description.damageFound': ' ',

	'timeout.bottom': ' ',
	'timeout.headline.first': 'Poveznica za aplikaciju više nije aktivna',

	'button.reverse': 'Sačuvaj snimljenu fotografiju',
	'button.confirm': 'Potvrdi prijeđene kilometre',
	'mileageModal.headline':
		'Provjerimo je li vrijednost prijeđenih kilometara koju ste unijeli točna',
	'mileageModal.paragraph':
		'Vrijednost prijeđenih kilometara učitanih s fotografije ne podudara se od one upisane u polje. Promijenite vrijednost ili potvrdite za nastavak ukoliko ustanovite da je vrijednost koju ste unijeli točna.',
	'mileageModal.insertedMileagePlaceholder': 'Unesena vrijednost prijeđenih kilometara',
	'mileageModal.pictureMileage': 'Vrijednost prijeđenih kilometara preuzeta s fotografije',
	'serviceErrorModal.headline': 'Unexpected error occured',
	'serviceErrorModal.close': 'OK',

	'serviceErrorModal.paragraph.first': 'Unexpected error has occured, please reload the page.',
	'serviceErrorModal.paragraph.second': 'If the error is persistent, reach out for support.',
	'serviceErrorModal.paragraph.details':
		'Please share any additional detail (e.g., screenshot) that could help us reproduce the error.',

	'invalidFile.size.title': 'Neodgovarajuća veličina fotografije',
	'invalidFile.size.description': 'Veličina slike je veća od maksimalno dopuštene veličine',
	'invalidFile.extension.title': 'Ova vrsta dokumenata nije podržana',
	'invalidFile.extension.description': 'Ova vrsta dokumenata nije podržana.',
};

export default messages;
